module.exports = __webpack_public_path__ + "DINNextLTPro-BlackItalic.woff2?0f187cc592c2d110dc53f2f9626547fe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BlackItalic.woff2
// module id = 1445
// module chunks = 0